import '../../resources/css/footer.css';
import AboutUs from "../footer/AboutUs";
import CategoryNews from "../footer/CategoryNews";
import LastNews from "../footer/LastNews";

export default function Footer() {

    return (
        <div>
            <div className="footer-top"></div>
            <div className="footer">
                
                <AboutUs></AboutUs>
                <CategoryNews></CategoryNews>
                <LastNews></LastNews>

            </div>
        </div>
    );
};